import Topics from "components/Topics/Topics";


const TopicsPage: React.FC = () => {
  return <Topics />;
};
  
export default TopicsPage;